
// let data=[
//     {
//       "image": "img1.jpg",
//       "name": "Lucas Franklin",
//       "profession": "Blogger",
//       "ratingColor": "#ff0f5b"
//     },
//     {
//       "image": "img2.jpg",
//       "name": "Flora Ocean",
//       "profession": "Web Developer",
//       "ratingColor": "#be01fe"
//     },
//     {
//       "image": "img3.jpg",
//       "name": "John Kendric",
//       "profession": "YouTuber",
//       "ratingColor": "#fea401"
//     },
//   ];
//   export default data;
  

import p1_img from './product_1.png'
import p2_img from './product_2.png'
import p3_img from './product_3.png'
import p4_img from './product_4.png'
import p5_img from './product_5.png'
import p6_img from './product_6.png'
import p7_img from './product_7.png'
import p8_img from './product_8.png'

let data = [
    {
      id:1,
      review:"It is A Genuine Platform,I Sell My Old Scooty Recently",
      image:p1_img,
      name:'Honey - China',
      profession:"Student",
      starvalue:4,
    },
    {id:2,
        review:"I've been using this platform for a while now, and I must say, it's genuine. " ,
      image:p2_img,
      name:'- John, USA',
      profession:"Student",
      starvalue:3,
    },
    {id:3,
        review:"This website is fantastic! I sold my antique furniture without any issues." ,
      image:p3_img,
      name:'- Emily, UK',
      profession:"Student",
      starvalue:5,
    },
    {id:4,
        review:"It's user-friendly, and I managed to sell my old laptop quickly. Will definitely use it again!" ,
      image:p4_img,
      name:'- Michael, Canada',
      profession:"Student",
      starvalue:4,
    },
    {
        id:5,
        review:"Highly impressed with the service.Easy to use and effective!" ,
        image:p5_img,
        name:'- Sophia, Australia',
        profession:"Student",
        starvalue:1,
      },
      {
        id:6,
        review:"The bidding process is smooth, and the interface is intuitive.",
        image:p6_img,
        name:'- Sarah, France',
        profession:"Student",
        starvalue:3,
      },
      {
        id:7,
        review:"It exceeded my expectations! Sold all my watches at fair prices." ,
        image:p7_img,
        name:'- Jessica ,America',
        profession:"Student",
        starvalue:4,
      },
      {
        id:8,
        review:"This platform is a lifesaver! I sold my old gaming console and books effortlessly." ,
        image:p8_img,
        name:'- Rachel, Italy',
        profession:"Student",
        starvalue:5,
      },
  ];
  
  export default data;